import react from 'react';
import {Row, Col} from 'react-bootstrap';

class SectionFour extends react.Component{
render() {
return(
<Row  className='background-color3'style={{textAlign: "center"}}>
<Col data-aos="slide-up" sm={12}>
<h1 className='font' style={{ color: "white", marginTop: "50px"}}>Our Story</h1>
<h5  className='font' style={{color: "white", marginTop: "-5px", marginBottom: '50px'}}>
  Nulla vitae elit libero, a pharetra augue mollis interdum.
  Nulla vitae elit libero, a pharetra augue mollis interdum.
  Nulla vitae elit libero, a pharetra augue mollis interdum.
  Nulla vitae elit libero, a pharetra augue mollis interdum.
  Nulla vitae elit libero, a pharetra augue mollis interdum.
  Nulla vitae elit libero, a pharetra augue mollis interdum.
  Nulla vitae elit libero, a pharetra augue mollis interdum.
  Nulla vitae elit libero, a pharetra augue mollis interdum.
  Nulla vitae elit libero, a pharetra augue mollis interdum.
  Nulla vitae elit libero, a pharetra augue mollis interdum.
  Nulla vitae elit libero, a pharetra augue mollis interdum.
  Nulla vitae elit libero, a pharetra augue mollis interdum.
  Nulla vitae elit libero, a pharetra augue mollis interdum.
  Nulla vitae elit libero, a pharetra augue mollis interdum.
  </h5>
</Col>
</Row>
  )
 }
}

export default SectionFour;